import standardDark from '../../components/Icons/images/status/28_standard_dark.svg'
import closedDark from '../../components/Icons/images/status/28_closed_dark.svg'
import inactiveIcon from '../../components/Icons/images/status/28_standard_grey.svg'

export const GET_PLAN_REVISION = 'app/Plan/GET_PLAN_REVISION'
export const GET_PLAN_REVISION_DONE = 'app/Plan/GET_PLAN_REVISION_DONE'
export const GET_PLAN_REVISION_ERROR = 'app/Plan/GET_PLAN_REVISION_ERROR'
export const GET_PLAN_DONE = 'app/Plan/GET_PLAN_DONE'
export const GET_PLAN_ERROR = 'app/Plan/GET_PLAN_ERROR'
export const CLEAR_CURRENT_PLAN = 'app/Plan/CLEAR_CURRENT_PLAN'

export const MOVE_PIN_TO_PLAN = 'app/Plan/MOVE_PIN_TO_PLAN'
export const MOVE_PIN_TO_PLAN_DONE = 'app/Plan/MOVE_PIN_TO_PLAN_DONE'
export const CLEAR_PIN_MOVED = 'app/Plan/CLEAR_PIN_MOVED'
export const MOVE_PIN_TO_PLAN_ERROR = 'app/Plan/MOVE_PIN_TO_PLAN_ERROR'
export const REMOVE_MOVE_PIN_TO_PLAN_ERROR =
  'app/Plan/REMOVE_MOVE_PIN_TO_PLAN_ERROR'

export const SET_CURRENT_PLAN_ID = 'app/Plan/SET_CURRENT_PLAN_ID'
export const CLEAR_CURRENT_PLAN_ID = 'app/Plan/CLEAR_CURRENT_PLAN_ID'

// todo maybe find a better place for this? if we can avoid importing the icons for no reason
export const PIN_STATUSES = [
  {
    icon: standardDark,
    value: 'Open',
    titleId: 'open'
  },
  {
    icon: closedDark,
    value: 'Closed',
    titleId: 'closed'
  },
  {
    icon: inactiveIcon,
    value: 'Inactive',
    titleId: 'inactive'
  }
]

export const viewTypeOptions = {
  PLAN: 'plan',
  SPLIT: 'split',
  LIST: 'list'
}
